import { render, staticRenderFns } from "./PageMainLanding.vue?vue&type=template&id=02a28bb8&"
import script from "./PageMainLanding.vue?vue&type=script&lang=js&"
export * from "./PageMainLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports